import axios from 'axios'
import { APP_DATA } from '../data'

const normalizeApiUrl = (url) => String(url || '')
  .trim()
  .replace(/[?#].*$/, '')
  .replace(/\/+$/, '')

export const clasolSuiteApi = axios.create({
  baseURL: normalizeApiUrl(APP_DATA.apiUrl),
  withCredentials: true,
})

clasolSuiteApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config
    const isAuthEndpoint = String(originalRequest?.url || '').startsWith('/auth/')

    if (error.response?.status !== 401 || originalRequest?._retry || isAuthEndpoint) {
      return Promise.reject(error)
    }

    originalRequest._retry = true

    try {
      await clasolSuiteApi.post('/auth/refresh')
      return clasolSuiteApi(originalRequest)
    } catch (refreshError) {
      return Promise.reject(refreshError)
    }
  },
)
